import { omit, pulseMerge } from '@spt-tracking/utils';
import consentsBuilder from './consents';
import { DEFAULT_SCHEMA_LOCATION } from './events-node';
import experimentMetadataBuilder, { defaultValue as experimentMetadataDefaultValue } from './experimentMetadata';
import experimentsBuilder, { defaultValue as experimentsDefaultValue } from './experiments';
import objectBuilder, { defaultValue as objectDefaultValue } from './objects/objects-anonymous';
import originBuilder, { defaultValue as originDefaultValue } from './origin';
import providerBuilder, { defaultValue as providerDefaultValue } from './provider';
import trackerBuilder, { defaultValue as trackerDefaultValue } from './tracker';
/**
 * Add default values to AnonymousTrackerEventInput.
 */
function trackerAnonymousEventInput(eventInput) {
    return pulseMerge({
        experiments: experimentsDefaultValue(),
        experimentMetadata: experimentMetadataDefaultValue(),
        object: objectDefaultValue(),
        origin: originDefaultValue(),
        provider: providerDefaultValue(),
        tracker: trackerDefaultValue(),
    }, eventInput);
}
export function anonymousTrackerEvent({ eventInput, sdkConfig } = {}) {
    const parentInput = trackerAnonymousEventInput(eventInput);
    return Object.assign({}, omit(eventInput, ['type']), {
        '@type': eventInput?.type || 'View',
        schema: eventInput?.schema ||
            `http://${sdkConfig?.schemaLocation || DEFAULT_SCHEMA_LOCATION}/events/tracker-event.json/351.json`,
        consents: consentsBuilder(parentInput),
        experiments: experimentsBuilder(parentInput),
        experimentMetadata: experimentMetadataBuilder(parentInput),
        object: objectBuilder(parentInput),
        origin: originBuilder(parentInput),
        provider: providerBuilder(parentInput),
        target: parentInput.target && objectBuilder(Object.assign({}, parentInput, { object: parentInput.target })),
        tracker: trackerBuilder(parentInput),
        isAnonymous: true,
    });
}
anonymousTrackerEvent.defaults = trackerAnonymousEventInput;
export function anonymousEngagementEvent({ eventInput, sdkConfig } = {}) {
    return Object.assign(anonymousTrackerEvent({ eventInput, sdkConfig }), {
        schema: eventInput?.schema ||
            `http://${sdkConfig?.schemaLocation || DEFAULT_SCHEMA_LOCATION}/events/engagement-event.json/378.json`,
        '@type': 'Engagement',
    });
}
anonymousEngagementEvent.defaults = trackerAnonymousEventInput;
